import { render, staticRenderFns } from "./StudentSummarySection.vue?vue&type=template&id=665539de&scoped=true"
import script from "./StudentSummarySection.vue?vue&type=script&lang=js"
export * from "./StudentSummarySection.vue?vue&type=script&lang=js"
import style0 from "./StudentSummarySection.vue?vue&type=style&index=0&id=665539de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665539de",
  null
  
)

export default component.exports